






angular.module('forms.fields.currency', [])
//.controller('CurrencyFieldController', CurrencyFieldController);
.directive('currencyField', function(){
return {
	require: 'ngModel',
	restrict: 'A',
	scope: true,
	link: function($scope, element, attrs, ngModel) {
		$scope.val = {
			currency:$scope.defaultCurrency || $scope.$root.defaultCurrency,
			amount: null
		};
		$scope.$watch('val', function(val) {
			var value = {};
			if (val && val.currency && val.amount !== null && val.amount !== '') value[val.currency] = parseFloat(val.amount);
			ngModel.$setViewValue(value);
		}, true);
		
		ngModel.$render = function() {
			$scope.val.currency = $scope.defaultCurrency || $scope.$root.defaultCurrency;
			$scope.val.amount = null;
			for (var currency in ngModel.$modelValue) {
				$scope.val.currency = currency;
				$scope.val.amount = ngModel.$modelValue[currency];
			}
    	};
    	window.ngModel = ngModel;
	},
}

});